"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = testWhitelistedErrors;

var _getApiErrors = _interopRequireDefault(require("./get-api-errors"));

var _getWhitelistedErrorFields = _interopRequireDefault(require("./get-whitelisted-error-fields"));

/**
 * Iterates over any errors present in the payload of an action. If there are any errors determining
 * the fields or unsupported errors encountered this function will throw an error. The intent is for
 * these errors to be caught and handled as part of the 'test'.
 *
 * @param {Object} action - a redux action
 */
function testWhitelistedErrors(action) {
  var errors = (0, _getApiErrors.default)(action);
  errors.forEach(function (error) {
    return (0, _getWhitelistedErrorFields.default)(error.code);
  });
}